var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdownicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64316 7.28936L5.62924 7.27711L5.61446 7.26593C5.09378 6.87184 4.35414 6.91632 3.88402 7.39587C3.37199 7.91817 3.37199 8.76094 3.88402 9.28323L11.061 16.6041L11.0738 16.6172L11.0876 16.6293L11.1799 16.7106L11.1938 16.7229L11.2086 16.7341C11.7293 17.1282 12.4689 17.0837 12.939 16.6041L20.116 9.28323L20.1288 9.27017L20.1406 9.25621L20.2203 9.16205L20.2322 9.14802L20.243 9.13316C20.623 8.61077 20.5823 7.87157 20.116 7.39587L20.1031 7.38278L20.0894 7.37065L19.9971 7.28937L19.9832 7.27711L19.9684 7.26593C19.4477 6.87184 18.7081 6.91632 18.2379 7.39587L18.2379 7.39588L12 13.7592L5.76208 7.39588L5.74924 7.38278L5.73547 7.37065L5.64316 7.28936Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdownicon);
export default __webpack_public_path__ + "static/media/arrowdown.icon.48f1a4e98965a530194388985f88c29f.svg";
export { ForwardRef as ReactComponent };